import type { Icon } from '../../../src/lib/types'
export const mdiMonitorSmall: Icon = {
  "id": "monitor-small",
  "name": "Monitor Small",
  "path": "M19 2H5C3.89 2 3 2.89 3 4V16C3 17.11 3.9 18 5 18H10V20H8V22H16V20H14V18H19C20.11 18 21 17.11 21 16V4C21 2.89 20.1 2 19 2M19 16H5V4H19V16Z",
  "as": [
    "monitor-crt"
  ],
  "tags": [
    "Device / Tech"
  ]
}
export default mdiMonitorSmall